/**
 * SmartImprove admin API client — wraps every CRUD endpoint under
 * /api/admin/smartimprove/*. Uses `withCredentials` so the admin JWT cookie
 * flows through. Pattern mirrors /app/frontend/src/lib/adminApi.js so the
 * Admin Panel keeps a consistent feel.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/smartimprove`;
const ax = axios.create({ baseURL: API, withCredentials: true });

// Generic helpers — each library exposes the same 4 CRUD verbs.
const crud = (entity) => ({
  list: () => ax.get(`/${entity}`).then((r) => r.data),
  create: (d) => ax.post(`/${entity}`, d).then((r) => r.data),
  update: (id, d) => ax.put(`/${entity}/${id}`, d).then((r) => r.data),
  remove: (id) => ax.delete(`/${entity}/${id}`).then((r) => r.data),
});

export const operationalAreasApi = crud("operational-areas");
export const subProcessesApi = crud("sub-processes");
export const issueLibraryApi = crud("issue-library");
export const kpiLibraryApi = crud("kpi-library");
export const insightTemplatesApi = crud("insight-templates");
export const recommendationTemplatesApi = crud("recommendation-templates");
export const roiModelsApi = crud("roi-models");
export const implementationTemplatesApi = crud("implementation-templates");
export const assignmentRulesApi = crud("assignment-rules");
export const playbookApi = crud("playbook");
export const aiGuidanceApi = crud("ai-guidance");

// Singletons
export const engagementDefaultsApi = {
  get: () => ax.get("/engagement-defaults").then((r) => r.data),
  put: (d) => ax.put("/engagement-defaults", d).then((r) => r.data),
};

export const reportTemplateApi = {
  get: () => ax.get("/report-template").then((r) => r.data),
  put: (d) => ax.put("/report-template", d).then((r) => r.data),
};

// Value Benchmarks (June 2026) — simplified replacement for legacy roi-models.
export const valueBenchmarksApi = {
  get: () => ax.get("/value-benchmarks").then((r) => r.data),
  put: (d) => ax.put("/value-benchmarks", d).then((r) => r.data),
};

export const catalogueApi = {
  get: () => ax.get("/catalogue").then((r) => r.data),
};
